import React, { FC } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { useLocalAnalyticsState } from "../../../graphql/hooks";
import styles from "./DailyBadges.module.scss";

interface Props {
    gameplay?: number;
    endScreen?: number;
    impressions?: number;
}

const DailyCTRImplementation: FC<Props> = ({
    gameplay,
    endScreen,
    impressions
}) => {
    const { analyticsEnabled } = useLocalAnalyticsState();

    if (
        !analyticsEnabled ||
        (!gameplay && !endScreen) ||
        !impressions ||
        impressions <= 0
    ) {
        return null;
    }
    const ctr = (
        (((gameplay || 0) + (endScreen || 0)) / impressions) *
        100
    ).toFixed(1);

    return (
        <>
            <div className={`${styles.analyticsText} text-inverse`}>
                <OverlayTrigger
                    placement="top"
                    delay={{ show: 200, hide: 100 }}
                    overlay={
                        <Tooltip id="daily-badge-tooltip-ctr">
                            CTR - previous 24 hrs
                        </Tooltip>
                    }
                >
                    <span style={{ whiteSpace: "nowrap" }}>
                        {parseFloat(ctr).toLocaleString()}{" "}
                        <span className="text-inverse">%</span>
                    </span>
                </OverlayTrigger>
            </div>
        </>
    );
};

export const DailyCTR = React.memo(DailyCTRImplementation);
